/**
 * Flux Intime — révélation au scroll.
 * Chaque élément est observé une seule fois puis relâché :
 * zéro travail au scroll une fois la page parcourue.
 *
 *   data-flux-reveal            fondu + montée du bloc entier
 *   data-flux-reveal="fade"     fondu seul
 *   data-flux-letters           montée lettre par lettre (grands titres only)
 *   style="--flux-delay: 200ms" décale le départ
 */
(function () {
  // Signale au filet de sécurité de flux-head.liquid que le script est bien là.
  window.__fluxReveal = true;

  var SELECTOR = '[data-flux-reveal], [data-flux-letters]';

  function each(root, fn) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
  }

  /**
   * Découpe le texte en mots puis en lettres. Les mots restent des blocs
   * insécables : sans ça, un titre qui passe à la ligne se briserait
   * n'importe où au milieu d'un mot.
   */
  function splitLetters(el) {
    if (el.dataset.fluxSplit) return;
    el.dataset.fluxSplit = 'true';

    var step = parseInt(el.dataset.fluxLetters, 10) || 26;
    var parts = el.textContent.replace(/\s+/g, ' ').trim().split(' ');
    var fragment = document.createDocumentFragment();
    var index = 0;

    for (var w = 0; w < parts.length; w++) {
      var word = document.createElement('span');
      word.className = 'flux-word';

      for (var c = 0; c < parts[w].length; c++) {
        var letter = document.createElement('span');
        letter.className = 'flux-letter';
        letter.style.setProperty('--flux-letter-delay', index * step + 'ms');
        letter.textContent = parts[w][c];
        word.appendChild(letter);
        index++;
      }

      fragment.appendChild(word);
      if (w < parts.length - 1) fragment.appendChild(document.createTextNode(' '));
    }

    el.textContent = '';
    el.appendChild(fragment);
  }

  function prepare(el) {
    if (el.hasAttribute('data-flux-letters')) splitLetters(el);
  }

  function showAll() {
    each(document, function (el) {
      el.classList.add('is-visible');
    });
  }

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || prefersReduced) {
    showAll();
    document.addEventListener('DOMContentLoaded', showAll);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-visible');
        observer.unobserve(entries[i].target);
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
  );

  function observe(root) {
    each(root, function (el) {
      if (el.dataset.fluxObserved) return;
      el.dataset.fluxObserved = 'true';
      prepare(el);
      observer.observe(el);
    });
  }

  observe(document);
  document.addEventListener('DOMContentLoaded', function () {
    observe(document);
  });

  // Éditeur de thème : les sections sont re-rendues à la volée.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
